import React, { useEffect, useRef } from "react";
import { Outlet, useLoaderData, useLocation, useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import styles from "@/styles/AdminNav.module.css";
import SideNav from "@/components/SideNav";

export default function AdminLayout() {
  const user = useLoaderData(); // comes from usersLoader in main.jsx
  const { accounts, inProgress } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();
  const mainRef = useRef(null);

  useEffect(() => {
    mainRef.current?.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  // Protect admin routes - redirect to home if not authenticated
  useEffect(() => {
    // Don't redirect while MSAL is processing login/logout
    if (inProgress !== "none") {
      console.log("MSAL operation in progress:", inProgress);
      return;
    }

    // Give MSAL a moment to populate accounts after redirect
    const timer = setTimeout(() => {
      if (!accounts || accounts.length === 0) {
        console.log("No MSAL account found - redirecting to home");
        navigate("/", { replace: true });
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [accounts, inProgress, navigate]);

  // Show loading while MSAL is processing
  if (inProgress !== "none") {
    return <div>Loading...</div>;
  }

  // Don't render admin content if not authenticated
  if (!accounts || accounts.length === 0) {
    return null;
  }

  return (
    <div className={styles.layout}>
      <nav>
        <SideNav />
      </nav>

      <main
        id="router-outlet-wrapper"
        data-label="ACTIVE-PAGE-CONTENT"
        className={styles.main}
        ref={mainRef}
        tabIndex={0}
      >
        {/* pass user into children via Outlet context */}
        <Outlet context={{ user }} />
      </main>
    </div>
  );
}
